import type { ChangeEventHandler } from "react";
import useTranslator from "../../hooks/useTranslator";

interface EmailInputProps {
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
}

const EmailInput = ({ value, onChange, disabled }: EmailInputProps) => {
  const { _t } = useTranslator();
  return (
    <div className="main-form-group">
      <div className="form-group">
        <label>{_t("email")}</label>
        <input
          type="text"
          placeholder={_t("enterEmail", "Text used in onboarding process")}
          name="email"
          onChange={onChange}
          value={value}
          required
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default EmailInput;
